import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import actions from './actions.js';
import mutations from './mutations.js';
import getters from './getters.js';
import contractorHistory from './contractor_history/index.js';
import modalConnectWith from './modal_connect_with/index.js';
import modalGenerateBalance from './modal_generate_balance/index.js';
import payments from './payments/index.js';
import priceList from './price_list/index.js';
import alerts from './alerts/index.js';
import agingReceivabilitiesAndLiabilities from './aging_receivabilities_and_liabilities/index.js';
import clientForm from './client_form/index.js';
import modalGenerateRootOperationBalance from './modal_generate_root_operation_balance/index.js';
import generateTransferList from './generate_transfer_list/index.js';
import contractForm from './contract-form/index.js';

Vue.use(Vuex);

const state = {
    userInfo: {username: '', department_id: undefined, default_currency: ''},
    stored_translations: {},
    select2ContractorsList: [{text: '---', id: 0}],
    select2IdNumbersList: [{text: '---', id: 0}],
    select2DocumentsCurrenciesList: [],
    server_info: {},
    countries_translations: {},
};

const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    modules: ['payments', 'generateTransferList', 'contractForm']
});

export default new Vuex.Store({
    state,
    mutations,
    getters,
    actions,
    modules: {
        contractorHistory,
        modalConnectWith,
        modalGenerateBalance,
        priceList,
        alerts,
        agingReceivabilitiesAndLiabilities,
        payments,
        clientForm,
        modalGenerateRootOperationBalance,
        generateTransferList,
        contractForm
    },
    plugins: [vuexLocal.plugin]
})
